export default "__VITE_ASSET__bPjFA5pz__"